var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0833 0H2.91668C1.30665 0.00194141 0.00194141 1.30665 0 2.91668V11.0834C0.00194141 12.6934 1.30665 13.9981 2.91668 14H11.0834C12.6934 13.9981 13.9981 12.6934 14 11.0833V2.91668C13.9981 1.30665 12.6934 0.00194141 11.0833 0ZM11.6667 4.71275L6.2685 10.1109C5.81298 10.5666 5.07429 10.5668 4.61858 10.1113C4.61847 10.1111 4.61836 10.111 4.61825 10.1109L2.33332 7.8266C2.10506 7.59834 2.10506 7.22827 2.33332 7.00003C2.56159 6.77179 2.93166 6.77176 3.1599 7.00003L5.44422 9.28435L10.843 3.88618C11.0712 3.65873 11.4407 3.65939 11.6681 3.88762C11.8956 4.11589 11.8949 4.4853 11.6667 4.71275Z",
    fill: "#329189"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.6ce1bd03771631cf8b09e423a5281b8a.svg";
export { ForwardRef as ReactComponent };